<template>
  <div>
    <div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%"
          border
          v-loading="listLoading"
      >
        <el-table-column property="createTime" label="时间"/>
        <el-table-column property="" label="禁言记录">
          <template #default="scope">
            <p v-if="scope.row.expireType == 0">禁言{{scope.row.days}}天</p>
            <p v-if="scope.row.expireType == 1">手动操作解除</p>
            <p v-if="scope.row.expireType == 2">自动过期解除</p>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getBannedHistoryPageList } from '@/api/url'
import { getFormData } from '@/api/api'
import ImgViewer from '../../../../assets/js/imageViewer'

export default {
  name: "InviteDetailDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.id,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['id'] = this.userId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getBannedHistoryPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
